import { graphql } from '../graphql';

/**
 * Layer-context entry point: takes an existing POINTCLOUD layer + the current
 * ClipBox state + the desired output format (LAZ or E57) and returns the
 * synthetic batch ID created by the server. Mirrors `startGroundClassification`
 * in groundClassify.query.ts.
 */
export const startClipboxExport = graphql(`
  mutation StartClipboxExport($input: StartClipboxExportInput!) {
    startClipboxExport(input: $input)
  }
`);
